import { Capacitor, registerPlugin } from '@capacitor/core';
import type { HealthImportBatch } from '../types';

interface HealthKitPlugin {
  isAvailable(): Promise<{ available: boolean }>;
  requestAuthorization(): Promise<{ granted: string[]; denied: string[] }>;
  collect(options: { days: number; timezone: string }): Promise<HealthImportBatch>;
}

const HealthKit = registerPlugin<HealthKitPlugin>('HealthKitBridge');

export async function healthKitAvailability(): Promise<boolean> {
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') return false;
  try {
    return (await HealthKit.isAvailable()).available;
  } catch {
    return false;
  }
}

export async function authorizeHealthKit(): Promise<{ granted: string[]; denied: string[] }> {
  return HealthKit.requestAuthorization();
}

export async function collectHealthKit(days: number, timezone = 'Asia/Taipei'): Promise<HealthImportBatch> {
  return HealthKit.collect({ days, timezone });
}

